
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/profile",
      function () {
        return require("private-next-pages/user/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/profile"])
      });
    }
  